module.exports = __webpack_public_path__ + "media/images/512-19e69d76d567cd8966dd839b49302f09.png";